<template>
  <el-row type="flex" :gutter="15">
    <el-col :span="14">
      <el-row v-show="showTitleToolbar" class="title-bar vertical-center-box" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 mr-r10">
            <span v-if="selectedManagetypeName !== null">{{selectedManagetypeName}} </span>
            관리 대상
          </div>
          <el-radio-group v-if="type==='both'" class="mr-r10" v-model="tableType" size="mini">
            <el-radio-button label="LOGICAL">논리</el-radio-button>
            <el-radio-button label="PHYSICAL">물리</el-radio-button>
          </el-radio-group>
          <w-tree-select-component ref="treeSelectComponent" v-if="type!=='physical'" v-show="active&&tableType==='LOGICAL'" :active="active"
          @select="selectManagegroup"/>
          <w-obj-type-filter ref="objTypeFilter" v-if="type!=='logical'" v-show="active&&tableType==='PHYSICAL'" :active="active"
          :managetype-data="managetypeData" :selected-managetype-id="selectedManagetypeId" :init-load="true" @filter-change="changeObjTypeFilter"
          :except-define-ids="exceptDefineIds" :except-objtype-ids="exceptObjtypeIds" :obj-define-ids="objDefineIds" :objtype-ids="objtypeIds" :hiddenNetdeviceChildren="hiddenNetdeviceChildren"/>
        </div>
        <w-header-search-button @click="showSearchTool = !showSearchTool" size="mini" />
      </el-row>
      <w-logical-obj-table ref="logicalObjTable" v-if="type!=='physical'" v-show="active&&tableType==='LOGICAL'" :active="active"
      :managegroup-data="managegroupData" @change-search-tool="showSearchTool = false" :show-search-tool="showSearchTool && tableType === 'LOGICAL'"
      :checked-obj-list="checkedObjList" @change-obj-list="changeObjList"
      :except-define-ids="exceptDefineIds" :except-objtype-ids="exceptObjtypeIds" :obj-define-ids="objDefineIds" :objtype-ids="objtypeIds" :hiddenNetdeviceChildren="hiddenNetdeviceChildren"/>
      <w-physical-obj-table ref="physicalObjTable" v-if="type!=='logical'" v-show="active&&tableType==='PHYSICAL'" :active="active"
      @change-search-tool="showSearchTool = false" :show-search-tool="showSearchTool && tableType === 'PHYSICAL'" :filter-params="filterParams"
      :checked-obj-list="checkedObjList" @show-interface-list="changeTitleToolbarShowFlag" :vm-template-flag="vmTemplateFlag"
      :show-interface-column="showInterfaceColumn" :show-netdevice-selection="showNetdeviceSelection" @change-obj-list="changeObjList"
      :except-define-ids="exceptDefineIds" :except-objtype-ids="exceptObjtypeIds" :obj-define-ids="objDefineIds" :objtype-ids="objtypeIds" :hiddenNetdeviceChildren="hiddenNetdeviceChildren"/>
    </el-col>
    <el-col :span="10">
      <w-selected-obj-table ref="selectedObjTable" :checked-obj-list="checkedObjList" @reload-obj-list="reloadObjList" @change-obj-list="changeObjList" />
    </el-col>
  </el-row>
</template>

<script>
import { isNil, isEqual } from 'lodash';
import WTreeSelectComponent from './components/TreeSelectComponent';
import WObjTypeFilter from './components/ObjTypeFilter';
import WLogicalObjTable from './components/LogicalObjTable';
import WPhysicalObjTable from './components/PhysicalObjTable/index';
import WSelectedObjTable from './components/SelectedObjTable';

export default {
  name: 'WCheckObjTable',
  components: {
    WTreeSelectComponent,
    WObjTypeFilter,
    WLogicalObjTable,
    WPhysicalObjTable,
    WSelectedObjTable,
  },
  props: {
    // 논리/물리/논리물리 테이블을 구분하는 변수
    // 논리:logical/물리:physical/논리-물리:both 테이블을 구분하는 변수
    type: {
      type: String,
      default: 'both',
    },
    active: {
      type: Boolean,
      default: false,
    },
    // 기존에 선택된 관리대상 리스트
    checkedObjList: {
      type: Array,
      default: () => [],
    },
    // 제외할 objDefineId들을 배열로 정의한다
    exceptDefineIds: {
      type: Array,
      default: () => [],
    },
    // 제외할 objtypeId들을 배열로 정의한다.
    exceptObjtypeIds: {
      type: Array,
    },
    // 필터링할 objDefineId들을 배열로 정의한다.
    objDefineIds: {
      type: Array,
    },
    // 필터링할 objtypeId들을 배열로 정의한다.
    objtypeIds: {
      type: Array,
    },
    // 물리테이블 : 물리 테이블 영역의 관리구분 리스트, 따로 지정해주지 않으면 activeManagetypesToShow를 사용
    managetypeData: {
      type: Array,
      default: () => [],
    },
    // 물리테이블 : 물리 테이블 영역에서 특정 managetypeId만을 보여준다
    selectedManagetypeId: {
      type: String,
      default: null,
    },
    // 물리테이블
    vmTemplateFlag: {
      type: String,
      default: null,
    },
    // 물리테이블 : 권한관련 설정에서는 인터페이스가 필요가 없기때문에 인터페이스 컬럼을 보여주지 않는다
    showInterfaceColumn: {
      type: Boolean,
      default: true,
    },
    // 물리테이블 : 물리테이블에서 인터페이스 대상만을 선택하기 위한 변수 (selectedManagtypeId = "NMS" 로 하고 showNetdeviceSelection = false로 한다)
    showNetdeviceSelection: {
      type: Boolean,
      default: true,
    },
    // 네트워크 장비를 부모로 가지는 관리 대상 숨김 여부
    hiddenNetdeviceChildren: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    tableType() {
      this.reloadObjList();
    },
  },
  data() {
    return {
      tableType: null,
      showSearchTool: false,
      managegroupData: null,
      filterParams: null,
      showTitleToolbar: true,
    };
  },
  computed: {
    selectedManagetypeName() {
      if (isNil(this.selectedManagetypeId)) {
        return null;
      }
      const activeManagetypes = this.$store.state.common.activeManagetypes;
      if (isNil(activeManagetypes)) {
        return null;
      }
      const selectedManagetype = activeManagetypes.find((item) => item.managetypeId === this.selectedManagetypeId);
      if (isNil(selectedManagetype)) {
        return null;
      }
      return selectedManagetype.managetypeName;
    },
  },
  mounted() {
    this.tableType = this.type === 'physical' ? 'PHYSICAL' : 'LOGICAL';
  },
  methods: {
    initData() {
      if (this.type === 'both') {
        this.tableType = 'LOGICAL';
      }
      this.managegroupData = null;
      this.filterParams = null;
      this.showSearchTool = false;
      if (this.type !== 'physical') {
        this.$refs.treeSelectComponent.initData();
        this.$refs.logicalObjTable.initData();
      }
      if (this.type !== 'logical') {
        this.$refs.objTypeFilter.loadManagetype();
        this.$refs.physicalObjTable.initData();
      }
      this.$refs.selectedObjTable.initData();
    },
    /**
     * 2019-08-12
     * [ND에 관련된 netinterface를 서비스단에서 추가/삭제할 것이기에 관련된 ND 대상만 보내도록한다.]
     * 추가적으로 서비스(SVC)는 관리대상의 element_id들과 기존 objId 권한 중복 및 판단이 어려워 현재 기능 유지
     * @author Song
     */
    getDeviceAuthSettingData() {
      const checkedObjList = this.checkedObjList;
      const objIds = [];
      checkedObjList.forEach((object) => {
        const objId = object.objId;
        if (!objIds.includes(objId) && object.objDefineId !== 'NETINTERFACE') {
          objIds.push(objId);
        }
      });
      const data = {
        objIds,
        flowAnalysisAuthFlag: this.flowAnalysisAuth,
      };
      return data;
    },
    reloadObjList() {
      const value = this.tableType;
      if (!isNil(value)) {
        if (isEqual(value, 'LOGICAL')) {
          this.$refs.logicalObjTable.setCheckObjTable();
        } else {
          this.$refs.physicalObjTable.setCheckObjTable();
        }
      }
    },
    selectManagegroup(data) {
      this.managegroupData = data;
    },
    changeObjTypeFilter(params, columns) {
      this.filterParams = {
        params,
        columns,
      };
    },
    changeTitleToolbarShowFlag(flag) {
      this.showTitleToolbar = flag;
    },
    changeObjList(objList, flag) {
      this.$emit('change-obj-list', objList, flag);
    },
  },
};
</script>

<style lang="scss">
.device-auth-setting {
  .el-button--mini {
    -webkit-padding-before: 7px !important;
    padding-top: 8px;
  }
  .el-radio-group.ordinary {
    .el-radio-button__inner {
      -webkit-padding-before: 9px !important;
      padding-top: 8px;
      padding-right: 12px;
      -webkit-padding-after: 8px !important;
      padding-bottom: 9px;
      padding-left: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table/CheckObjTable/index.vue